import { DOCUMENT } from '@angular/common';
import { Component, effect, HostListener, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { LangService } from '@reforgium/presentia';
import { SkDynamicDialogHostComponent } from '@ss/ui';

import { urls } from 'constants/urls.constant';

import { AccessibilityService } from 'features/accessibility/accessibility.service';
import { AccessibilityHoverSpeechComponent } from 'features/accessibility/accessibility-hover-speech.component';
import { AccessibilityPanelComponent } from 'features/accessibility/accessibility-panel.component';
import { UpdateBannerComponent } from 'features/update-banner';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    SkDynamicDialogHostComponent,
    UpdateBannerComponent,
    AccessibilityPanelComponent,
    AccessibilityHoverSpeechComponent,
  ],
  template: `
    <app-update-banner />
    <app-accessibility-panel />
    <router-outlet />
    <app-accessibility-hover-speech />
    <sk-dynamic-dialog-host />
  `,
  styles: [],
})
export class AppComponent {
  private readonly router = inject(Router);
  private readonly accessibility = inject(AccessibilityService);
  private readonly document = inject(DOCUMENT);
  private readonly language = inject(LangService);

  constructor() {
    effect(() => {
      this.document.documentElement.lang = this.language.currentLang() === 'ky' ? 'ky' : 'ru';
    });
  }

  @HostListener('window:keydown', ['$event'])
  handleGlobalKeydown(event: KeyboardEvent): void {
    if (event.key !== 'F8') {
      return;
    }

    event.preventDefault();
    void this.router.navigate([urls.signIn]);
  }
}
